<app-modal [open]="open()" [title]="title()" (closed)="cancelled.emit()">
  <div #dialogRoot role="alertdialog" aria-modal="true" [attr.aria-label]="title()">
    <p class="text-sm text-gray-700">{{ message() }}</p>

    <div class="mt-6 flex justify-end gap-2">
      <span #cancelHost>
        <app-button variant="secondary" [disabled]="submitting()" (clicked)="cancelled.emit()">
          {{ cancelLabel() }}
        </app-button>
      </span>
      <app-button
        [variant]="variant() === 'danger' ? 'danger' : 'primary'"
        [loading]="submitting()"
        (clicked)="confirmed.emit()"
      >
        {{ confirmLabel() }}
      </app-button>
    </div>
  </div>
</app-modal>
